import AppBarDropdownMenu from "./AppBarDropdownMenu";
import AppBarLogo from "./AppBarLogo";
import AppBarUserMenu from "./AppBarUserMenu";
import SessionTimer from "../core/SessionTimer";
import { AppBar, Box, Toolbar } from "@mui/material";
import { useAppBarMenu } from "../../hooks/useAppBarMenu";

/**
 * Główny komponent AppBar
 * Działa jako orkiestrator - koordynuje logo, powiadomienia, menu użytkownika i dropdown
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko orkiestracja
 */
export default function ModernAppBar() {
  const { anchorEl, open, handleProfileClick, handleClose, handleSettings } = useAppBarMenu();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: "#ffffff",
        mt: 0,
        border: "1px solid #ddd",
        borderBottom: "none",
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 56, sm: 64 },
          px: { xs: 2, sm: 3 },
        }}
      >
        {/* Logo/Nazwa aplikacji */}
        <AppBarLogo />

        {/* Spacer */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Menu użytkownika */}
        <AppBarUserMenu onProfileClick={handleProfileClick} />

        {/* Menu dropdown */}
        <AppBarDropdownMenu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onSettings={handleSettings}
        />

        {/* Zegar sesji jako przycisk wylogowania - na końcu */}
        <SessionTimer />
      </Toolbar>
    </AppBar>
  );
}
